import { cn } from "@/lib/utils";

/**
 * Loading placeholder.
 *
 * A shimmer sweep rather than a pulse: a sweep reads as "work is
 * happening", where a fade reads as "this element is disabled". The
 * gradient is built from the foreground colour at low alpha so it inherits
 * paper-and-ink in light mode and ink-and-bone in dark with one definition.
 *
 * Respects prefers-reduced-motion — the sweep stops, the block stays.
 */
function Skeleton({
  className,
  ...props
}: React.HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      aria-hidden="true"
      className={cn(
        "relative overflow-hidden rounded-md bg-foreground/[0.055]",
        "after:absolute after:inset-0 after:-translate-x-full",
        "after:bg-gradient-to-r after:from-transparent after:via-foreground/[0.05] after:to-transparent",
        "after:animate-shimmer",
        "motion-reduce:after:hidden",
        className,
      )}
      {...props}
    />
  );
}

export { Skeleton };
